import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { useParams, useLocation, useSearchParams } from "react-router-dom";
import { DeliveryType } from "types/deliveryType.enum";
import { OrderSourceEnum } from "types/orderSource.enum";

const { RangePicker } = DatePicker;

type OrderManagementTableHeadersProps = {
  status?: string;
  total?: number;
  startDate?: string;
  endDate?: string;
  onDateSearchChange: (start: string, end: string) => void;
};

export const OrderManagementTableHeaders = ({
  status,
  total = 0,
  startDate,
  endDate,
  onDateSearchChange,
}: OrderManagementTableHeadersProps) => {
  const isStartDateValid = dayjs(startDate).isValid();
  const isEndDateValid = dayjs(startDate).isValid();

  const deliveryTypeValues = Object.values(DeliveryType);
  const sourceOptions = Object.values(OrderSourceEnum);

  const [searchParams, setSearchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams);
  console.log("🚀 ~ searchParams:", params);

  const getTextWithDefault = (text: string, defaultValue = "") =>
    text === "all" ? defaultValue : text;

  return (
    <div className="px-4 flex justify-between">
      <div className="text-black font-medium">
        {status ?? "All"} Orders ({total || 0})
      </div>

      <div className="flex gap-2">
        <div className="flex gap-2">
          <select
            title="source"
            id="source"
            className={
              "border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md capitalize"
            }
            value={searchParams.get("source") ?? ""}
            onChange={(e) => {
              setSearchParams({
                ...params,
                source: getTextWithDefault(e?.target?.value),
              });
            }}
          >
            <option value="" disabled>
              Source
            </option>
            {["all", ...sourceOptions].map((value) => (
              <option key={value} value={value} className="capitalize">
                {value}
              </option>
            ))}
          </select>
          <select
            title="deliveryMethod"
            id="deliveryMethod"
            className={
              "border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md capitalize"
            }
            value={searchParams.get("deliveryMethod") ?? ""}
            onChange={(e) => {
              setSearchParams({
                ...params,
                deliveryMethod: getTextWithDefault(e?.target?.value),
              });
            }}
          >
            <option value="" disabled>
              Delivery
            </option>
            {["all", ...deliveryTypeValues].map((value) => (
              <option key={value} value={value} className="capitalize">
                {value}
              </option>
            ))}
          </select>

          <select
            id="paymentStatus"
            title="paymentStatus"
            className={
              "border-[1px] duration-300 border-[#d3d3d3] focus:border-orange rounded-md capitalize"
            }
            value={searchParams.get("paymentStatus") ?? ""}
            onChange={(e) => {
              setSearchParams({
                ...params,
                paymentStatus: getTextWithDefault(e?.target?.value),
              });
            }}
          >
            <option value="" disabled>
              Payment status
            </option>
            {["all", "pending", "paid"].map((value) => (
              <option key={value} value={value} className="capitalize">
                {value}
              </option>
            ))}
          </select>
        </div>
        <RangePicker
          value={[
            isStartDateValid ? dayjs(startDate) : null,
            isEndDateValid ? dayjs(endDate) : null,
          ]}
          onCalendarChange={(_, dateStrings) => {
            const [startDate, endDate] = dateStrings.map((s) =>
              s ? dayjs(s).toISOString() : ""
            );
            onDateSearchChange?.(startDate, endDate);
          }}
        />
      </div>
    </div>
  );
};
